import React from 'react';
import ImportData from '../components/importData';
import { usePortfolio } from '../contexts/PortfolioContext'; // Portfolio context'ini import ediyoruz

function ImportDataPage() {
  // Portfolio context'inden gerekli değerleri alıyoruz
  const { 
    selectedPortfolio: currentPortfolio, 
    refreshPortfolios 
  } = usePortfolio();

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
          Portföy Verisi İçe Aktarma
        </h1>
        <p className="mt-2 text-gray-600 dark:text-gray-400">
          PDF dosyanızı sürükleyip bırakarak portföy verilerinizi içe aktarabilirsiniz.
        </p>
      </div>
      
      <div className="bg-white dark:bg-[#151934] shadow-sm rounded-lg p-6">
        <ImportData 
          activePortfolio={currentPortfolio} 
          refreshPortfolios={refreshPortfolios}
        />
      </div>
    </div>
  );
}

export default ImportDataPage;